export enum PeriodType {
  M1 = 'M1',
  M3 = 'M3',
  Y1 = 'Y1',
  Y2 = 'Y2',
  Y3 = 'Y3',
  Y5 = 'Y5',
  MAX = 'MAX',
  NOW = 'NOW',
}
export interface PriceEntity {
  readonly date: number;
  readonly close: number | null;
}
